import React from 'react';
import './styles.css';

import { Line } from 'react-chartjs-2';


const data = {
  labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
  datasets: [{
    data: [18, 51, 60, 38, 88, 50, 40, 52, 88, 80, 60, 70],
    label: "Custo total",
    backgroundColor: "transparent",
    borderColor: "#377dff",
    borderWidth: 2,
    pointRadius: 0,
    hoverBorderColor: "#377dff",
    pointBackgroundColor: "#377dff",
    pointBorderColor: "#fff",
    pointHoverRadius: 0
  },
  {
    data: [27, 38, 60, 77, 40, 50, 49, 29, 42, 27, 42, 50],
    label: "Não indenizados",
    backgroundColor: "transparent",
    borderColor: "#00c9db",
    borderWidth: 2,
    pointRadius: 0,
    hoverBorderColor: "#00c9db",
    pointBackgroundColor: "#00c9db",
    pointBorderColor: "#fff",
    pointHoverRadius: 0
  }]
};

const options: any = {
  plugins: {
    title: {
      display: false,
    }
  },
  scales: {
    yAxes: [{
      gridLines: {
        color: "#e7eaf3",
        drawBorder: false,
        zeroLineColor: "#e7eaf3"
      },
      ticks: {
        min: 0,
        max: 100,
        stepSize: 20,
        fontColor: "#97a4af",
        fontFamily: "Open Sans, sans-serif",
        padding: 10,
        postfix: "k"
      }
    }],
    xAxes: [{
      gridLines: {
        display: false,
        drawBorder: false
      },
      ticks: {
        fontSize: 12,
        fontColor: "#97a4af",
        fontFamily: "Open Sans, sans-serif",
        padding: 5
      }
    }]
  },
  tooltips: {
    prefix: "$",
    postfix: "k",
    hasIndicator: true,
    mode: "index",
    intersect: false,
    lineMode: true,
    lineWithLineColor: "rgba(19, 33, 68, 0.075)"
  },
  hover: {
    mode: "nearest",
    intersect: true
  }
};

interface TypeProps {
  title: string
}

export default function WidgetChartLine({ title }: TypeProps) {
  return (
    <div id='container-widget-chart-line'>
      <h1>{title}</h1>
      <div id='widget-chart'>
        <Line data={data} options={options} />
      </div>
    </div>
  )
}
